import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatPaginator as MatPaginator, MatPaginatorIntl as MatPaginatorIntl, PageEvent as PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Control } from 'src/models/control';
import { HelperService } from 'src/services/helperService';
import { CreationClientsComponent } from './Dialogs/creation-clients/creation-clients.component';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { User } from 'src/models/user';
import { tap } from 'rxjs';
import { CustomPaginator } from '../CustomPaginatorConfiguration';
import { EditionClientsComponent } from './Dialogs/edition-clients/edition-clients.component';
import { DeleteClientDialog } from './Dialogs/delete-clients/delete-clients.dialog';

@Component({
    selector: 'app-clients',
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.sass'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ],
    standalone: false
})
export class ClientsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  onAddControlClick = (param: string): void => {};
  ClientData:any[]=[]
  pagesize: number = 16;
  desde: number = 0;
  hasta: number = 16;
  pagesCount: number = 0;
  selectedPage: number = 0;
  rowPerPage: number = 16;
  paginatorLength: number= 0
  FilterEmail:string = "";
  FilterFirstName:string = "";
  FilterLastName:string = "";
  FilterTypeName:string = "";
  FilterIdentification:string = "";




  ClientLoading : boolean = false
  user:User= this.helperService.user
  id=  this.user.countryId
  constructor( public helperService: HelperService,
    public dialog: MatDialog,
    private translate: TranslateService,public customerBasicDataService: APICustomerBasicDataService,) { }

  ngOnInit(): void {

    this.desde = 0
    this.hasta = this.pagesize
    this.ClientLoading =  false
    this.helperService.TitlePage = 'Adminclients'
    this.helperService.icon = 'edit';
    this.getClientManagement()

  }

  // Function Pagination

  changePage(e: PageEvent) {
    this.pagesize = e.pageSize;
    this.desde = e.pageIndex * e.pageSize;
    this.hasta = this.desde + e.pageSize;
  }

  resetPagination(): void {
    this.desde = 0;
    this.hasta = this.pagesize;
    this.paginator?.firstPage();
  }

  // Function show icons hover
 onIconMouseHoverAndOut(
  elementId: string,
  className: string,
  isFill: boolean
) {
  if (isFill) {
    document.getElementById(elementId)?.classList.add(className + '-fill');
    document.getElementById(elementId)?.classList.remove(className);
  } else {
    document.getElementById(elementId)?.classList.add(className);
    document.getElementById(elementId)?.classList.remove(className + '-fill');
  }
}

controls: Control[] = [
  {
    icon: 'bi bi-plus-lg',
    description: 'Add Workshops',
    action: this.onAddControlClick,
  },
];

getClientManagement(){

    this.customerBasicDataService.getForCoutry(this.id!).pipe(tap((response) => {

      if(!response.message){
      this.ClientData = response
      this.paginatorLength = response.length
    }else {
      const translateTxtNotMatch = this.translate.instant("notMatchFound")

          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =translateTxtNotMatch
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)
    }
      this.ClientLoading =  true

    })).subscribe({
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    })

}




createClient() {
  const dialogRef = this.dialog.open(CreationClientsComponent, {
    width: '800px',
    panelClass: 'icon-outside',
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result==="refreshCustomer"){this.ngOnInit()}
  });

}


EditInfoclient(user: any) {
  const dialogRef = this.dialog.open(EditionClientsComponent, {
    width: '700px',
    panelClass: 'icon-outside',
    data: user
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result==="refreshCustomer"){this.ngOnInit()}

  });

}

DeleteClient(user:any) {
  const dialogRef = this.dialog.open(DeleteClientDialog, {
    width: '512px',
    panelClass: 'icon-outside',
    data:user,
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result==="refreshCustomer"){this.ngOnInit()}
  });

}
}
